import React, { useState, useEffect } from "react";
import { auth, db } from "../firebase";
import { useSubscriptionStatus } from "../hooks/useSubscriptionStatus";
import { doc, getDoc } from "firebase/firestore";
import "../styles/Account.css";

const Account = () => {
  const [user, setUser] = useState(null);
  const [subscriptionDetails, setSubscriptionDetails] = useState(null);
  const { isActive, isExpired, isFree } = useSubscriptionStatus();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (user) {
        setUser(user);
        // 현재 이용권 정보 가져오기
        const userDoc = await getDoc(doc(db, "users", user.uid));
        const userData = userDoc.data();

        const subscription = userData?.subscription;
        setSubscriptionDetails(subscription);
      }
    });

    return () => unsubscribe();
  }, []);

  const handleLogout = async () => {
    try {
      // 현재 구독 상태를 로컬 스토리지에 저장
      const currentSubscriptionState =
        localStorage.getItem("subscriptionState");

      await auth.signOut();

      // 로그아웃 후에도 구독 상태 유지
      localStorage.setItem("subscriptionState", currentSubscriptionState);
    } catch (error) {
      console.error("로그아웃 에러:", error);
    }
  };

  if (!user) return null;

  return (
    <div className="account-container">
      <h2>계정 설정</h2>

      <div className="account-info-section">
        <h3>기본 정보</h3>
        <div className="info-item">
          <label>이메일</label>
          <p>{user.email}</p>
        </div>
        <div className="info-item">
          <label>계정 생성일</label>
          <p>{new Date(user.metadata.creationTime).toLocaleDateString()}</p>
        </div>
      </div>

      <div className="account-info-section">
        <h3>이용권 정보</h3>
        {subscriptionDetails ? (
          <div className="subscription-info">
            <div className="info-item">
              <label>상태</label>
              {isActive ? (
                <p className="active-subscription">이용 중</p>
              ) : (
                <p className="inactive-subscription">이용 불가</p>
              )}
            </div>
            <div className="info-item">
              <label>구매한 이용권</label>
              <p>{subscriptionDetails.packageType || "프리미엄 이용권"}</p>
            </div>
            <div className="info-item">
              <label>시작일</label>
              <p>
                {subscriptionDetails.startDate?.toDate().toLocaleDateString() ||
                  "정보 없음"}
              </p>
            </div>
            <div className="info-item">
              <label>만료일</label>
              <p>
                {subscriptionDetails.endDate?.toDate().toLocaleDateString() ||
                  "정보 없음"}
              </p>
            </div>
          </div>
        ) : (
          <div className="subscription-info">
            <p className="free-mode">무료 버전 이용 중</p>
          </div>
        )}
      </div>

      <div className="account-actions">
        <button className="logout-button" onClick={handleLogout}>
          로그아웃
        </button>
      </div>

      <div className="account-info-section">
        <h3>고객지원</h3>
        <div className="info-item">
          <label>문의 이메일</label>
          <p>support@toeicmon.com</p>
        </div>
      </div>
    </div>
  );
};

export default Account;
